const $trainingsTable = $('table.trainings__dates');
const $trainingsFilter = $('.trainings_filter');
const $trainingTextarea = $('div.form-trainings textarea[readonly]');
const $trainingBtn = $('div.form-trainings span.btn-group button');
const $trainingBtnBack = $('div.form-trainings span.btn-group.previous button');
const $trainingsDatesBtn = $('div.training-view__dates button[type=submit]');

$trainingsTable.tablePagination({
  perPage: 10,
  position: 'top',
  paginationClass: 'table-pagination'
});

$('.table-pagination > li').on('click', function () {
  $trainingsFilter.val('');
});

$trainingsFilter.each(function forEachTrainingsFilter() {
  const $this = $(this);
  const $table = $('.trainings__dates');

  $this.on('change', function () {
    $('.table-pagination > li').removeClass('current');

    let value = $this.val().toLowerCase();
    $table.find('tbody > tr').show().filter(function () {
      $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
    });
  });
});

$trainingTextarea.autoResize().change();

$trainingBtn.addClass('btn--azure').addClass('btn--quarter-wide');

$trainingBtnBack.on('click', function (event) {
  event.preventDefault();
  history.back();
});

$trainingsTable.find(':checkbox').on('change', function () {
  let checked = $trainingsTable.find(':checked');

  if (checked.length) {
    $trainingsDatesBtn.show();
  } else {
    $trainingsDatesBtn.hide();
  }
})
